export const THUOC_TINH_PERMISSION_CODES = {
  WEB_BH_THUOC_TINH_LIST: 'WEB_BH_THUOC_TINH_LIST',
  WEB_BH_THUOC_TINH_ADD: 'WEB_BH_THUOC_TINH_ADD',
  WEB_BH_THUOC_TINH_EDIT: 'WEB_BH_THUOC_TINH_EDIT',
  WEB_BH_THUOC_TINH_DELETE: 'WEB_BH_THUOC_TINH_DELETE',
} as const
